<template>
    <span>
        <b-button
            class="align-baseline btn-circle-minus"
            title="Remove"
            variant="danger"
            @click="removeItem"
            size="xs"
            v-if="params.data.id !== null && !params.node.rowPinned && params.data.status !== 0"
        ><font-awesome-icon :icon="['fas', 'minus']"></font-awesome-icon></b-button>
    </span>
</template>

<script>
    export default {
        methods: {
            removeItem() {
                this.params.deleteItem(this.params.data.id, this.params.data.tech_res_id);
            },
        },
    };
</script>
